import { useState, useEffect, useContext } from "react";
import Context from "../../storage/context";
import FavoritesModal from "../FavoritesModal/FavoritesModal";

const Hero = () => {
    let ctx = useContext(Context);
    const MAKES = [...new Set(ctx.getAllCars.map(item => item.car_make))];
    const KMS = ["עד 30,000", "30,000–60,000", "60,000–100,000", "100,000+"];

    let [YEARS, setYears] = useState([...new Set(ctx.getAllCars.map(item => item.year))]);

    useEffect(() => {
        const getyears = () => {
            if (ctx.getSearch.make !== "") {
                setYears([...new Set(ctx.getAllCars.filter(car => car.car_make === ctx.getSearch.make).map(item => item.year))].sort((a, b) => a - b));
                ctx.setSearch({ ...ctx.getSearch, year: "", km: "" })
            } else {
                setYears([...new Set(ctx.getAllCars.map(item => item.year))].sort((a, b) => a - b));
                ctx.setSearch({ ...ctx.getSearch, year: "", km: "", click: false })
            }
        };
        getyears();
    }, [ctx.getSearch.make]);

    const onClickSearch = () => {
        if (ctx.getSearch.btn_text === "חפש עכשיו" && !ctx.getSearch.click) {
            document.getElementById("cars-section").scrollIntoView({ behavior: "smooth" });
            ctx.setSearch({ ...ctx.getSearch, btn_text: "בטל סינון", click: true });
        } else {
            ctx.setSearch({ year: "", km: "", make: "", btn_text: "חפש עכשיו", click: false });
        }
    };

    return (
        <section className="hero">
            <div className="hero-car-bg" />
            <div className="hero-car-fade" />
            <div className="hero-inner">
                <div className="hero-eyebrow">רועי קאר - מומחה ברכבי יד 2</div>
                <h1 className="hero-title">
                    מוצאים את הרכב<br />
                    <span>המושלם עבורכם</span>
                </h1>
                <p className="hero-sub">
                    מאות רכבים מיד שנייה . שקיפות מלאה, תהליך פשוט, מחיר הוגן.
                </p>
                <div className="search-card">
                    <div className="s-field">
                        <div className="s-label">יצרן</div>
                        <select className="s-select" value={ctx.getSearch.make} onChange={e => ctx.setSearch({ ...ctx.getSearch, make: e.target.value })} disabled={ctx.getSearch.click || ctx.getFavCars}>
                            <option value="">כל היצרנים</option>
                            {MAKES.map(m => <option key={m}>{m}</option>)}
                        </select>
                    </div>
                    <div className="s-field">
                        <div className="s-label">שנת ייצור</div>
                        <select className="s-select" value={ctx.getSearch.year} onChange={e => ctx.setSearch({ ...ctx.getSearch, year: e.target.value })} disabled={ctx.getSearch.click || ctx.getFavCars}>
                            <option value="">כל השנים</option>
                            {YEARS.map(y => <option key={y}>{y}</option>)}
                        </select>
                    </div>
                    <div className="s-field">
                        <div className="s-label">קילומטרז׳</div>
                        <select className="s-select" value={ctx.getSearch.km} onChange={e => ctx.setSearch({ ...ctx.getSearch, km: e.target.value })} disabled={ctx.getSearch.click || ctx.getFavCars}>
                            <option value="">כל הטווחים</option>
                            {KMS.map(k => <option key={k}>{k}</option>)}
                        </select>
                    </div>
                    <button className="s-btn" onClick={onClickSearch} disabled={ctx.getFavCars && ctx.getArrFavCars.length !== 0}>{ctx.getSearch.btn_text}</button>
                </div>
                <div style={{ marginTop: "16px" }}>
                    <FavoritesModal />
                </div>
            </div>


        </section>
    );
};

export default Hero;